/* Curvite x Weave — section behaviour. One asset serves every section. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ANIM = '.wv-rail__head, .wv-card, .wv-gal__tile, .wv-rt__inner, .wv-mt__media, .wv-mt__box, .wv-bn__box, .wv-fp__media, .wv-fp__box, .wv-cl__card, .wv-bl__card, .wv-q__item, .wv-lg__item';
  var TRACKS = '.wv-rail__track, .wv-cl__scroller';

  function initHero(root) {
    var slides = root.querySelectorAll('.wv-hero__slide');
    var dots = root.querySelectorAll('.wv-hero__dot');
    if (slides.length < 2) return;
    var i = 0, timer;
    function go(n) {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
      reveal(slides[i]);
    }
    function play() {
      if (root.dataset.autoplay !== 'true' || reduce) return;
      clearInterval(timer);
      timer = setInterval(function () { go(i + 1); }, (parseInt(root.dataset.speed, 10) || 6) * 1000);
    }
    Array.prototype.forEach.call(dots, function (d, n) {
      d.addEventListener('click', function () { go(n); play(); });
    });
    play();
  }

  function initCountdown(el) {
    var end = new Date(el.dataset.end).getTime();
    if (isNaN(end)) { el.style.display = 'none'; return; }
    var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'),
        m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    var timer = setInterval(tick, 1000);
    function tick() {
      var left = end - Date.now();
      if (left <= 0) { el.style.display = 'none'; clearInterval(timer); return; }
      var sec = Math.floor(left / 1000);
      d.textContent = pad(Math.floor(sec / 86400));
      h.textContent = pad(Math.floor(sec % 86400 / 3600));
      m.textContent = pad(Math.floor(sec % 3600 / 60));
      s.textContent = pad(sec % 60);
    }
    tick();
  }

  function initRail(root) {
    var track = root.querySelector('[data-wv-track]');
    var prev = root.querySelector('[data-wv-prev]');
    var next = root.querySelector('[data-wv-next]');
    if (!track || !prev) return;
    function step() {
      var card = track.firstElementChild;
      return card ? card.getBoundingClientRect().width + 16 : 300;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  var PATH = 'M4,17.24C96.84,4.14,191.06,1.01,284,4.58c-136.78,2.51-143.55,5.27-222.75,16.38,84.81-4.84,122.59-6.71,160.15-5.77';
  var NS = 'http://www.w3.org/2000/svg';

  function buildHighlights(scope) {
    var hosts = (scope || document).querySelectorAll('.wv-hero__h, .wv-bn__h, .wv-h2');
    Array.prototype.forEach.call(hosts, function (el) {
      if (el.dataset.wvHl || el.textContent.indexOf('[') === -1) return;
      el.dataset.wvHl = '1';
      var parts = el.innerHTML.split(/\[([^\]]+)\]/);
      var out = '';
      for (var i = 0; i < parts.length; i++) {
        out += (i % 2) ? '<span class="wv-hl">' + parts[i] + '</span>' : parts[i];
      }
      el.innerHTML = out;
      Array.prototype.forEach.call(el.querySelectorAll('.wv-hl'), function (span) {
        var svg = document.createElementNS(NS, 'svg');
        svg.setAttribute('class', 'wv-hl__svg');
        svg.setAttribute('viewBox', '0 0 288 24');
        svg.setAttribute('preserveAspectRatio', 'none');
        svg.setAttribute('aria-hidden', 'true');
        var p = document.createElementNS(NS, 'path');
        p.setAttribute('d', PATH);
        svg.appendChild(p);
        span.appendChild(svg);
        try { span.style.setProperty('--wv-len', Math.ceil(p.getTotalLength())); } catch (e) {}
        observe(span);
      });
    });
  }

  var io = null;
  function reveal(scope) {
    if (!scope) return;
    scope.classList.add('wv-in');
    var els = scope.querySelectorAll(ANIM + ', .wv-hl');
    Array.prototype.forEach.call(els, function (el) { el.classList.add('wv-in'); });
  }
  function observer() {
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          /* a horizontal track reveals every card it holds, including the ones
             parked off-screen to the right which would otherwise never
             intersect the viewport and would stay invisible for good */
          if (e.target.matches(TRACKS)) reveal(e.target);
          else e.target.classList.add('wv-in');
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    return io;
  }
  function observe(el) {
    if (reduce) { el.classList.add('wv-in'); return; }
    observer().observe(el);
  }

  function boot(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('.wv-hero'), initHero);
    Array.prototype.forEach.call(root.querySelectorAll('.wv-cd'), initCountdown);
    Array.prototype.forEach.call(root.querySelectorAll('[data-wv-rail]'), initRail);
    buildHighlights(root);
    Array.prototype.forEach.call(root.querySelectorAll(TRACKS), observe);
    Array.prototype.forEach.call(root.querySelectorAll(ANIM), function (el) {
      if (el.closest(TRACKS)) return;
      observe(el);
    });
    var hero = document.querySelector('.wv-hero .wv-hero__slide.is-active');
    if (hero) reveal(hero);
  }

  /* The header sits transparent over the hero and goes solid the moment the
     hero's bottom edge reaches it. Measuring the hero's live rect rather than
     guessing from scrollY keeps that exact at any hero or header height. */
  function headerWatch() {
    var hero = document.querySelector('.wv-hero');
    var de = document.documentElement;
    if (!hero || !de.classList.contains('wv-hero-header')) return;
    function headerH() {
      var v = parseFloat(getComputedStyle(de).getPropertyValue('--header-height'));
      return isNaN(v) ? 113 : v;
    }
    function onScroll() {
      de.classList.toggle('wv-scrolled', hero.getBoundingClientRect().bottom <= headerH());
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  function start() { boot(); headerWatch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
